import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import dog1 from './assets/image1.jpeg';

const AboutModal = ({ adventure, onClose }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 1024);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // ✅ Prevent background scroll
    useEffect(() => {
        const root = document.getElementById('root');
        if (root) root.style.overflow = 'hidden';

        const preventTouchScroll = (e) => e.preventDefault();
        document.body.addEventListener('touchmove', preventTouchScroll, { passive: false });

        return () => {
            if (root) root.style.overflow = '';
            document.body.removeEventListener('touchmove', preventTouchScroll);
        };
    }, []);

    return ReactDOM.createPortal(
        <div
            style={{
                position: 'fixed',
                inset: 0,
                backgroundColor: 'rgba(0,0,0,0.4)',
                zIndex: 4000,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                overscrollBehavior: 'contain',
            }}
            onClick={onClose}
        >
            <motion.div
                initial={{ x: '-100%' }}
                animate={{ x: 0 }}
                exit={{ x: '100%' }}
                transition={{ duration: 0.4, ease: 'easeInOut' }}
                style={{
                    backgroundColor: '#D9D9D9',
                    width: isMobile ? '100vw' : '80vw',
                    height: isMobile ? '100dvh' : '80vh',
                    borderRadius: isMobile ? '0' : '20px',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    position: 'relative',
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                    touchAction: 'none',
                    paddingTop: isMobile ? 'env(safe-area-inset-top)' : 0,
                    paddingBottom: isMobile ? 'env(safe-area-inset-bottom)' : 0,
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* 🖼️ Image Section */}
                <div
                    style={{
                        flex: isMobile ? '0 0 40%' : '0 0 40%',
                        height: isMobile ? '300px' : '100%',
                        position: 'relative',
                        overflow: 'hidden',
                        borderTopLeftRadius: isMobile ? '0' : '20px',
                        borderBottomLeftRadius: isMobile ? '0' : '20px',
                        flexShrink: 0,
                    }}
                >
                    <img
                        src={dog1}
                        alt="About Sadie"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                        }}
                    />

                    {/* ❌ White circular X button — only visible on mobile */}
                    {isMobile && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 'calc(15px + env(safe-area-inset-top))',
                                right: 15,
                                width: 40,
                                height: 40,
                                backgroundColor: 'white',
                                borderRadius: '50%',
                                display: isMobile ? 'flex' : 'none', // 👈 hidden on desktop
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: 'pointer',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
                                zIndex: 10,
                            }}
                            onClick={onClose}
                        >
                            <X size={22} color="#5FA89B" />
                        </div>
                    )}
                </div>

                {/* 📜 Scrollable Content */}
                <div
                    style={{
                        flex: 1,
                        overflowY: 'auto',
                        padding: isMobile ? '40px 25px' : '80px 100px',
                        whiteSpace: 'pre-line',
                        position: 'relative',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        WebkitOverflowScrolling: 'touch',
                        backgroundColor: '#D9D9D9',
                    }}
                >
                    <style>
                        {`
                            ::-webkit-scrollbar {
                                display: none;
                            }
                        `}
                    </style>

                    {/* ❌ Desktop X button (text area) */}
                    {!isMobile && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 24,
                                right: 28,
                                cursor: 'pointer',
                            }}
                            onClick={onClose}
                        >
                            <X size={32} color="#5FA89B" />
                        </div>
                    )}

                    <h2
                        style={{
                            fontFamily: "'Libre Baskerville', serif",
                            fontSize: isMobile ? '28px' : '42px',
                            marginBottom: '40px',
                            textAlign: 'center',
                            lineHeight: 1.2,
                            marginTop: isMobile ? '20px' : '0',
                        }}
                    >
                        About me...
                    </h2>

                    <p
                        style={{
                            fontFamily: "'Libre Baskerville', serif",
                            fontSize: isMobile ? '16px' : '20px',
                            lineHeight: 1.6,
                            textAlign: 'justify',
                        }}
                    >
                        {adventure.description}
                    </p>
                </div>
            </motion.div>
        </div>,
        document.body
    );
};

export default AboutModal;
